import { render, staticRenderFns } from "./ColumnDesign.vue?vue&type=template&id=cc364174"
import script from "./ColumnDesign.vue?vue&type=script&lang=js"
export * from "./ColumnDesign.vue?vue&type=script&lang=js"
import style0 from "./ColumnDesign.vue?vue&type=style&index=0&id=cc364174&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports